import React, { useEffect } from 'react';
import {
  about,
  about1,
  about2,
  about3,
  logoAbout,
  product1,
  product2,
  product3,
  product4,
  sertifikat1,
  sertifikat2,
  sertifikat3,
  sertifikat4,
  sertifikat5,
  sertifikat6,
  why1,
  why2,
  why3,
  why4,
  why5,
  why6,
  why7,
  why8,
  why9
} from '../../assets/images';
import { useTranslation } from 'react-i18next';
import AOS from "aos";
import "aos/dist/aos.css"; // AOS stil dosyasını import ediyoruz

const WhyUs = () => {
  const { t } = useTranslation();

    useEffect(() => {
      AOS.init({
        duration: 1000, // Animasyon süresi (ms)
        once: true, // Sadece bir kere animasyonu tetikle
      });
    }, []);
  

  const opportunitiesData = [
    { id: 1, image: why1,  title: "Təcrübəli Mütəxəssislər", description: "Dünyaca tanınmış həkimlər və yüksək ixtisaslı tibbi personal ilə xidmət göstəririk." },
    { id: 2, image: why2, title: "Müasir Təchizat", description: "Ən son texnologiya ilə təchiz edilmiş klinikalar və xəstəxanalar." },
    { id: 3, image: why3, title: "Fərdi Yanaşma", description: "Hər bir xəstəyə xüsusi müalicə planı və dəstək." },
    { id: 4, image: why4, title: "Şəffaf Qiymətlər", description: "Müalicə və xidmətlərin tamamilə aydın qiymət siyahısı." },
    { id: 5, image: why5, title: "Beynəlxalq Keyfiyyət", description: "Qlobal standartlara uyğun tibbi xidmət və təhlükəsizlik." },
    { id: 6, image: why6, title: "Tam Dəstək Xidməti", description: "Gəlişdən dönüşə qədər bütün səyahət və müalicə tənzimləmələri." },
    { id: 7, image: why7, title: "Premium Xidmətlər", description: "Tibbi xidmətlərdən əlavə, rahat səyahət və qalma imkanları təqdim edirik." },
    { id: 8, image: why8, title: "Sanatoriya Xidmətlər", description: "Sağlamlıq turizmi üçün unikal sanatoriyalar və reabilitasiya mərkəzləri." },
    { id: 9, image: why9, title: "Etibarlı Tərəfdaşınız", description: "Etibar və peşəkarlıqla həm müalicə, həm də güvən qazanın." }
  ];

  return (
    <div className="md:max-w-container max-w-containerSm mx-auto mt-[24px] md:mt-[56px]">
      <p >{t("Ana səhifə")} <i className={`fas fa-chevron-right text-[black] ml-3 mr-3`}/> {t("Niyə biz ?")}</p>
       <div className="md:max-w-container max-w-containerSm mx-auto mt-[24px] md:mt-[56px] md:flex justify-between">
         <div className='flex flex-col justify-center md:w-[479px] bg-white rounded-[24px]'>
      <img src={logoAbout}></img>
         </div>
         <div className='md:w-[745px] bg-[white] rounded-[24px] py-4 px-6'>
          <p className='md:text-[40px] md:leading-[50px] text-xl font-medium'>{t("Tibbi Turizmin Lideri - HEVO sizi qarşılayır !")}</p>
          <p className='mt-[18px] md:text-[20px]'>{t("HEVO Tibbi Turizm Şirkəti, beynəlxalq tibbi turizm sahəsində etibarlı tərəfdaşınız olaraq, həm öz ölkəmizdə, həm də xarici ölkələrdə nüfuzlu tibbi müəssisələrlə əməkdaşlıq edərək, müştərilərinə fərdi yanaşma, innovativ həllər və tam dəstək təmin edir.")}</p>
         {/* <a href='/why-us'>    <button className='h-[51px] w-full md:w-[164px] rounded-[12px] bg-[#FB8C00] text-white mt-[32px]'>Daha ətraflı</button></a> */}
         </div>
        </div>
        <div className='mt-[64px] md:mt-[104px]'>
     <div className="md:max-w-container max-w-containerSm mx-auto justify-between flex md:flex-row flex-col items-center gap-5">
    <div className='bg-[#388E3C] py-[24px] px-[16px] flex w-full flex-col justify-center items-center text-white rounded-[20px] md:w-[413px]'>
   <p className='text-[32px] font-semibold'>300 +</p>
   <p className='text-[18px]'>{t("Həkim")}</p>
    </div>
    <div className='bg-[#FB8C00] py-[24px] px-[16px] flex w-full flex-col justify-center items-center text-white rounded-[20px] md:w-[413px]'>
   <p className='text-[32px] font-semibold'>100 +</p>
   <p className='text-[18px]'>{t("Klinika")}</p>
    </div>
    <div className='bg-[#388E3C] py-[24px] px-[16px] flex w-full flex-col justify-center items-center text-white rounded-[20px] md:w-[413px]'>
   <p className='text-[32px] font-semibold'>200 +</p>
   <p className='text-[18px]'>{t("Şirkət")}</p>
    </div>
    </div>
   </div>
   <div className="max-w-containerSm md:max-w-container mx-auto mt-[64px] md:mt-[104px]">
      <div className="flex items-center justify-between">
        <p className="md:text-[46px] text-3xl font-medium">{t("Niyə biz ?")}</p>
      </div>
      <div className="grid md:grid-cols-3 mt-10 gap-10">
        {opportunitiesData.map((item) => (
          <div key={item.id} className="border-[1px] border-[#388E3C] rounded-[20px]" data-aos="fade-up">
            <img className="h-[194px] w-full rounded-t-[20px]" src={item.image} alt="Opportunity" />
            <div className="px-5">
              <p className="mt-[20px] text-2xl md:text-[24px] font-medium">{t(item.title)}</p>
              <p className="mt-[12px] mb-[20px]">{t(item.description)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="max-w-containerSm md:max-w-container mx-auto mt-[64px] md:mt-[104px]">
      <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-5">
      <div className="rounded-[20px]">
            <div >
            <div><span class="text-[#fb8c00] text-3xl md:text-[40px] font-medium ">{t("Bizimlə")}<br/></span><span class="text-[#0e0e0d] text-3xl md:text-[40px] font-medium ">{t("hədəflərinizə daha yaxın olun!")}</span></div>
              <p className='text-lg mt-4'>{t("Sizin inkişafınız və sağlamlığınız üçün buradayıq! Təcrübəmiz və peşəkarlığımızla fərq yaradacağıq.")}</p>
            </div>
          </div>
          <div className="border-[1px] border-[#388E3C] rounded-[20px]">
            <div className="px-5 py-5 md:text-xl">
              <p >{t("Biz, Azərbaycandan xaricə və xaricdən Azərbaycana həkimlər və tələbələr üçün peşəkar təcrübə imkanları təmin edərək, bilik və bacarıqlarını artırmaq istəyənlər üçün ideal bir platforma təqdim edirik. Hər iki tərəfin mədəni və elmi bilik mübadiləsini dəstəkləyirik.")}  </p>
            </div>
          </div>
          <div className="border-[1px] border-[#388E3C] rounded-[20px]">
            <div className="px-5 py-5 md:text-xl">
              <p >{t("Xaricdən Azərbaycana və Azərbaycandan xaricə xəstələrin müalicəsini peşəkar şəkildə təşkil edirik. Tibbi xidmətlərimizdə beynəlxalq standartlara uyğun müalicə proseslərini təmin edirik. Sizin sağlamlığınız bizim üçün ən böyük önəmlidir.")} </p>
            </div>
          </div>
          <div className="border-[1px] border-[#388E3C] rounded-[20px]">
            <div className="px-5 py-5 md:text-xl">
              <p >{t("Bütün ixtisaslar üzrə ölkələrarası həkim mübadiləsi ilə tibb sahəsində əməkdaşlıq imkanlarını genişləndirir və hər iki tərəf üçün bilik mübadiləsi yaradırıq. Hər bir həkim üçün unikal təcrübə və inkişaf şansı təqdim edirik.")}  </p>
            </div>
          </div>
          <div className="border-[1px] border-[#388E3C] rounded-[20px]">
            <div className="px-5 py-5 md:text-xl">
              <p >{t("Sizin üçün ən uyğun həkimləri, təcrübə proqramlarını və müalicə variantlarını seçmək üçün peşəkar və şəffaf yanaşmamız var. Bütün xidmətlərimizdə müştəri məmnuniyyətini prioritet tuturuq.")}</p>
            </div>
          </div>
          <div className="border-[1px] border-[#388E3C] rounded-[20px]">
            <div className="px-5 py-5 md:text-xl">
              <p >{t("Şirkətimiz, tibbi turizm sahəsində geniş beynəlxalq tərəfdaşlıqlara sahibdir. Bu, həm təcrübə proqramlarında, həm də müalicə proseslərində sizə ən yüksək keyfiyyətli xidmətləri təqdim etməyimizə imkan verir.")}</p>
            </div>
          </div>
          
      </div>
    </div>
    </div>
  );
};

export default WhyUs;